// extracted by mini-css-extract-plugin
export default {"headingWrapper":"HeadingField_headingWrapper__O2GLh","heading":"HeadingField_heading__YUbPF"};